import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';
new Accordion('.question-list');
